import React from "react";
import PropTypes from "prop-types";
import Icon from './Icon';
import { formatClassName } from '../Util';
import { kebabCase } from 'lodash';

/**
  This component will display a notication banner at the top of the page between PageWrapper and Header in style dependent on the type prop.
*/
const SystemBanner = ({ data = {}, text, label, icon, type }) => {

  const className = formatClassName([
    'system-banner',
    `system-banner-${type}`
  ])

  const dataProps = {};
  if (data.action) {
    dataProps['data-action'] = data.action;
  }
  if (data.objectId) {
    dataProps['data-object-id'] = data.objectId;
  }
  if (data.objectType) {
    dataProps['data-object-type'] = data.objectType;
  }
  if (data.componentType) {
    dataProps['data-component-type'] = data.componentType;
  } else {
    dataProps['data-component-type'] = type ? `${kebabCase(type)}-system-banner` : 'system-banner';
  }

  return (
    <div className={className} {...dataProps}>
      {icon && <Icon iconType={icon} />}
      {label && <div className="system-banner-label">{label}</div>}{text}
    </div>
  )
}

SystemBanner.propTypes = {
  /** This text will be displayed inside the SystemBanner */
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  data: PropTypes.object,
  /** Label text is bolded for attention grabbing */
  label: PropTypes.string,
  /** Icon to be displayed */
  icon: PropTypes.string,
  /** Color Type to be displayed */
  type: PropTypes.oneOf(['info', 'error', 'warning', 'success', 'generic'])
};

SystemBanner.defaultProps = {
  type: 'generic'
}

export default SystemBanner;
